import { NavBarPricing, ReferralIcon, RequestIcon } from '@ankr.com/ui';
import { t } from '@ankr.com/common';

import { AccountPermission } from 'modules/permissions/constants';
import { NavigationItem } from 'modules/common/components/Navigation/components/BaseNavButton';
import { pricingRoutesConfig } from 'domains/pricing/routes';
import { referralsRoutesConfig } from 'domains/referrals/routes';

import { ISecondMenuItemsParams } from '../types';
import { FEEDBACK_URL } from '../../../const';

export const getSecondMenuItems = ({
  isLoggedIn,
  isPartnerClient,
}: ISecondMenuItemsParams): NavigationItem[] => {
  const items: NavigationItem[] = [
    {
      StartIcon: NavBarPricing,
      href: pricingRoutesConfig.pricing.generatePath(),
      isHidden: isLoggedIn,
      label: t('main-navigation.pricing'),
      requiresPermission: AccountPermission.CommonMenuItem,
    },
    {
      StartIcon: ReferralIcon,
      href: referralsRoutesConfig.referrals.generatePath(),
      isDisabled: isPartnerClient,
      isHidden: !isLoggedIn,
      label: t('main-navigation.referrals'),
      requiresPermission: AccountPermission.CommonMenuItem,
    },
    {
      StartIcon: RequestIcon,
      href: FEEDBACK_URL,
      isCannyLink: true,
      isDisabled: false,
      isHidden: false,
      isNotLinkItem: true,
      label: t('main-navigation.request-feature'),
      requiresPermission: AccountPermission.CommonMenuItem,
    },
  ];

  return items.filter(item => !item.isHidden);
};
